import { KlaviyoForm } from 'graphql/generated/graphql';

export const matchesUrls = (urls: string, fullUrl: string) => {
  return !!urls.split(',').find((value) => fullUrl.includes(value));
};

export const formMatchesLocation = (
  form: Pick<KlaviyoForm, 'displayUrl' | 'includeUrls' | 'excludeUrls'>,
  pathname: string,
  search: string,
) => {
  const fullUrl = pathname + search;

  if (form.displayUrl !== pathname) return false;

  if (form.excludeUrls && matchesUrls(form.excludeUrls, fullUrl)) return false;

  if (form.includeUrls && !matchesUrls(form.includeUrls, fullUrl)) return false;

  return true;
};

export const klaviyoOpenForm = (formId: string) => {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
};
